import type { HTMLAttributes, ReactNode } from 'react';

type Props = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export function Card({ className = '', children, ...rest }: Props): JSX.Element {
  // Default p-4 (was p-6). Individual pages that need dense card
  // padding can override with `className="!p-3"` / `!p-2`; roomy
  // pages that need the old feel can override with `!p-6`.
  const cls = ['rounded-lg border border-border bg-bg p-4 shadow-card', className]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}
